(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-collections-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function refreshGridSlider(sectionEl) {
      var holder = sectionEl.querySelector('grid-slider');
      if (holder && typeof holder.refresh === 'function') {
        try {
          holder.refresh();
        } catch (e) {}
      } else if (holder && typeof holder.update === 'function') {
        try {
          holder.update();
        } catch (e) {}
      }
    }

    function applyGridFilter(sectionEl, letter) {
      var tiles = sectionEl.querySelectorAll('[data-range-az-tile]');
      if (!tiles.length) return;

      var featuredCount = sectionEl.querySelectorAll('[data-range-az-tile][data-featured-on-load="true"]').length;
      var useFeaturedInitial = featuredCount > 0;

      tiles.forEach(function (tile) {
        var show;
        if (letter === null) {
          if (useFeaturedInitial) {
            show = tile.getAttribute('data-featured-on-load') === 'true';
          } else {
            show = true;
          }
        } else {
          show = tile.getAttribute('data-range-filter-letter') === letter;
        }
        tile.hidden = !show;
        if (tile.hidden) {
          tile.setAttribute('aria-hidden', 'true');
        } else {
          tile.removeAttribute('aria-hidden');
        }
      });

      refreshGridSlider(sectionEl);
    }

    function initRangeAz(root) {
      var sectionEl = root.closest('section[data-section-type="list-collections"]');
      if (!sectionEl) return;

      if (root.hasAttribute('data-range-az-initialized')) {
        applyGridFilter(sectionEl, null);
        var viewAll = root.querySelector('[data-range-az-view-all]');
        if (viewAll) viewAll.hidden = true;
        root.querySelectorAll('[data-range-az-letter]').forEach(function (b) {
          b.setAttribute('aria-selected', 'false');
          b.classList.remove('is-active');
        });
        return;
      }
      root.setAttribute('data-range-az-initialized', '');

      var letterButtons = root.querySelectorAll('[data-range-az-letter]');
      var viewAllBtn = root.querySelector('[data-range-az-view-all]');
      if (!letterButtons.length) return;

      function setViewAllVisible(show) {
        if (!viewAllBtn) return;
        viewAllBtn.hidden = !show;
      }

      letterButtons.forEach(function (b) {
        b.setAttribute('aria-selected', 'false');
        b.classList.remove('is-active');
      });
      applyGridFilter(sectionEl, null);
      setViewAllVisible(false);

      function clearFilter() {
        letterButtons.forEach(function (b) {
          b.setAttribute('aria-selected', 'false');
          b.classList.remove('is-active');
        });
        applyGridFilter(sectionEl, null);
        setViewAllVisible(false);
      }

      function openLetter(letter, button) {
        letterButtons.forEach(function (b) {
          var sel = b === button;
          b.setAttribute('aria-selected', sel ? 'true' : 'false');
          b.classList.toggle('is-active', sel);
        });
        applyGridFilter(sectionEl, letter);
        setViewAllVisible(true);
      }

      letterButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var letter = btn.getAttribute('data-range-az-letter');
          if (!letter) return;
          openLetter(letter, btn);
        });
      });

      if (viewAllBtn) {
        viewAllBtn.addEventListener('click', clearFilter);
      }
    }

    function initCollectionsListSection(sectionEl) {
      var nav = sectionEl.querySelector('[data-range-az-nav]');
      if (nav) initRangeAz(nav);
    }

    function scan(container) {
      var scope = container || document;
      scope.querySelectorAll('section[data-section-type="list-collections"]').forEach(initCollectionsListSection);
    }

    scan(document);
    document.addEventListener('shopify:section:load', function (ev) {
      if (ev.target) scan(ev.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
